module.exports = __webpack_public_path__ + "img/shopping_application_2-2.93bdebae.jpg";